import { useState, useEffect } from 'react';
import { DogProfile } from '../types';
import { apiService } from '../services/apiService';

export const useDogProfile = () => {
  const [dogProfile, setDogProfile] = useState<DogProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadDogProfile = async () => {
    try {
      setLoading(true);
      const profile = await apiService.getDogProfile();
      setDogProfile(profile);
      setError(null);
    } catch (err) {
      setError('Failed to load dog profile');
      console.error('Error loading dog profile:', err);
    } finally {
      setLoading(false);
    }
  };

  const createDogProfile = async (name: string, imageBase64?: string) => {
    try {
      const newProfile = await apiService.createDogProfile({
        name,
        image_base64: imageBase64
      });
      setDogProfile(newProfile);
      return newProfile;
    } catch (err) {
      setError('Failed to create dog profile');
      throw err;
    }
  };

  const updateDogProfile = async (data: Partial<DogProfile>) => {
    try {
      if (!dogProfile) return;
      
      const updatedData = { ...dogProfile, ...data };
      await apiService.updateDogProfile(updatedData);
      setDogProfile(updatedData);
      setError(null);
    } catch (err) {
      setError('Failed to update dog profile');
      throw err;
    }
  };

  useEffect(() => {
    loadDogProfile();
  }, []);

  return {
    dogProfile,
    loading,
    error,
    loadDogProfile,
    createDogProfile,
    updateDogProfile
  };
};